import { Moment } from 'moment';
import { ScanStatus } from '../enums/ScanStatus';
import { Project } from './valueObjects/Project';

export class Scan {
  constructor(
    private readonly id: number,
    private readonly name: string,
    private readonly status: ScanStatus,
    private readonly endedAt: Moment | null,
    private readonly project: Project | null,
    private readonly startedAt: Moment,
    private readonly totalHosts: number,
    private readonly failedHosts: number,
    private readonly successfulHosts: number
  ) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getStatus() {
    return this.status;
  }

  isRunning() {
    return [ScanStatus.PENDING, ScanStatus.IN_PROGRESS].includes(this.status);
  }

  getEndedAt() {
    return this.endedAt;
  }

  getProject() {
    return this.project;
  }

  getStartedAt() {
    return this.startedAt;
  }

  getTotalHosts() {
    return this.totalHosts;
  }

  getFailedHosts() {
    return this.failedHosts;
  }

  getSuccessfulHosts() {
    return this.successfulHosts;
  }

  isSame(other: Scan) {
    return (
      this.id === other.id &&
      this.status === other.status &&
      this.totalHosts === other.totalHosts &&
      this.successfulHosts === other.successfulHosts &&
      this.failedHosts === other.failedHosts
    );
  }
}
